import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { IAngularMyDpOptions, IMyDateModel } from '@nodro7/angular-mydatepicker';
import moment from 'moment';

export interface IDateRangePicker {
    from: string;
    to: string;
}

@Component({
    selector: 'app-date-range-picker',
    templateUrl: './date-range-picker.component.html',
})
export class DateRangePickerComponent implements OnChanges {
    @Input() model: IDateRangePicker;
    @Output() modelChange: EventEmitter<IDateRangePicker> = new EventEmitter();
    @Input() placeholder: string;

    myDpOptions: IAngularMyDpOptions = {
        dateRange: true,
        dateFormat: 'dd/mm/yyyy',
        stylesData: {
            selector: 'dp1',
            styles: `
                .dp1 .myDpDimDay {
                    opacity:0.7;
                }
               .dp1 .myDpIconLeftArrow,
               .dp1 .myDpIconRightArrow,
               .dp1 .myDpHeaderBtn {
                   color: #0A123A;
                }
               .dp1 .myDpHeaderBtn:focus,
               .dp1 .myDpMonthLabel:focus,
               .dp1 .myDpYearLabel:focus {
                   color: #1c2862;
                }
               .dp1 .myDpDaycell:focus,
               .dp1 .myDpMonthcell:focus,
               .dp1 .myDpYearcell:focus {
                   box-shadow: inset 0 0 0 1px #1c2862;
                }
               .dp1 .myDpSelector:focus {
                   box-shadow: -1px 1px 6px 0px #1c2862;
                }
               .dp1 .myDpSelectorArrow:focus:before {
                   border-bottom-color: #1c2862;
                }
               .dp1 .myDpCurrMonth,
               .dp1 .myDpMonthcell,
               .dp1 .myDpYearcell {
                   color: #0A123A;
                }
               .dp1 .myDpDaycellWeekNbr {
                   color: #0A123A;
                }
               .dp1 .myDpPrevMonth,
               .dp1 .myDpNextMonth {
                   color: #6495ED;
                }
               .dp1 .myDpWeekDayTitle {
                   background-color: transparent;
                   color: #0A123A;
                   font-weight: bold;
                }
               .dp1 .myDpHeaderBtnEnabled:hover,
               .dp1 .myDpMonthLabel:hover,
               .dp1 .myDpYearLabel:hover,
               .dp1 .myDpFooterBtn:hover {
                   color: #1c2862;
                }
               .dp1 .myDpMarkCurrDay,
               .dp1 .myDpMarkCurrMonth,
               .dp1 .myDpMarkCurrYear {
                   border-bottom: 2px solid #ccc;
                }
               .dp1 .myDpDisabled {
                   color: #999;
                }
               .dp1 .myDpHighlight {
                   color: #f00;
                }
               .dp1 .myDpTableSingleDay:hover,
               .dp1 .myDpTableSingleMonth:hover,
               .dp1 .myDpTableSingleYear:hover {
                   background-color: #0A123A;
                   color: #ffffff;
                }
               .dp1 .myDpRangeColor {
                   background-color: #4252a5;
                   color: #fff;
                   font-weight: bold;
                }
               .dp1 .myDpSelectedDay,
               .dp1 .myDpSelectedMonth,
               .dp1 .myDpSelectedYear {
                   background-color: #0A123A;
                   font-weight: bold;
                }
             `,
        },
    };

    myDpModel: IMyDateModel;

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.model && changes.model.currentValue) {
            this.model = changes.model.currentValue;
            this.fromModelToMyDpModel();
        }
        if (changes && changes.placeholder && changes.placeholder.currentValue) {
            this.placeholder = changes.placeholder.currentValue;
        }
    }

    fromModelToMyDpModel() {
        this.myDpModel = {
            isRange: true,
            dateRange: { beginJsDate: moment(this.model.from).toDate(), endJsDate: moment(this.model.to).toDate() },
        };
    }

    onMyDpModelChange() {
        if (!this.myDpModel) {
            this.model = { from: null, to: null };
        } else {
            const fromParts = this.myDpModel.dateRange.formatted.slice(0, 10).split('/');
            const toParts = this.myDpModel.dateRange.formatted.slice(13, 23).split('/');
            this.model.from = fromParts[2] + '-' + fromParts[1] + '-' + fromParts[0];
            this.model.to = toParts[2] + '-' + toParts[1] + '-' + toParts[0];
        }
        this.modelChange.emit(this.model);
    }
}
